import LazyLoad from "vanilla-lazyload";
import Masonry from "masonry-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import zenscroll from "zenscroll";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import Player from "@vimeo/player";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const cursor = document.getElementById("cursor");
const body = document.querySelector("body");
const header = document.querySelector("header");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
/*
const overlay = document.getElementById("overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closer");
*/

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  // splash page loading sequence
  let splashEl = document.getElementById("splash");
  if (typeof splashEl != "undefined" && splashEl != null) {
    let bg1 = splashEl.querySelector(".bg1");
    let bg2 = splashEl.querySelector(".bg2");

    setTimeout(function () {
      bg1.classList.add("show");
    }, 1000);

    setTimeout(function () {
      bg2.classList.add("show");
    }, 2000);

    setTimeout(function () {
      splashEl.classList.add("hide");
      body.classList.remove("noscroll");
    }, 2500);
  }

  // gsap scroll animations

  if (body.classList.contains("textpage")) {
    const textShape1 = document.querySelector(".textpage .topShape");
    gsap.to(textShape1, {
      scrollTrigger: {
        trigger: body,
        start: "0",
        end: document.innerHeight,
        scrub: 1,
        markers: false,
      },
      y: 300,
    });
    const textShape2 = document.querySelector(".textpage .midShape");
    gsap.to(textShape2, {
      scrollTrigger: {
        trigger: body,
        start: "0",
        end: window.innerHeight,
        scrub: 1,
        markers: false,
      },
      y: 250,
    });
    const textShape3 = document.querySelector(".textpage .bottomShape");
    gsap.to(textShape3, {
      scrollTrigger: {
        trigger: body,
        start: "0",
        end: window.innerHeight,
        scrub: 1,
        markers: false,
      },
      y: -150,
    });
  }

  // check for any inline iframes
  let postIframes = document.querySelectorAll(".post iframe");
  postIframes.forEach((frame) => {
    resizePostIframe(frame);
  });

  // HORIZONTAL SCROLLING LOGOS

  if (document.querySelector(".scrolling-logos")) {
    const slides = gsap.utils.toArray(".scrolling-logos .cell");
    const loop = horizontalLoop(slides, {
      speed: 1,
      repeat: -1,
    });
  }

  // HORIZONTAL SCROLLING PHOTOS

  if (document.querySelector(".horz_scroll_wrap")) {
    const slidesPhotos = gsap.utils.toArray(
      ".horz_scroll_wrap .horz_scroll .cell"
    );

    let photoSpeed = 1;
    if (window.innerWidth <= 768) {
      photoSpeed = 0.5;
    }

    const loop = horizontalLoop(slidesPhotos, {
      speed: photoSpeed,
      repeat: -1,
    });
  }

  /*
  // footer hubspot styling
  setTimeout(function () {
    let footerForm = document.querySelector("footer form");
    console.log(footerForm);
  }, 5000);
  */

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  function arRowsWidow() {
    if (innerWidth <= 768) {
      return;
    }

    // check for single item in row to adjust size
    let theRows = document.querySelectorAll(".ar-rows .row");
    let rowCount = theRows.length;
    let lastRow = theRows[rowCount - 1];
    let lastRowCells = lastRow.querySelectorAll(".cell");
    let lastRowCellCount = lastRowCells.length;
    if (lastRowCellCount == 1) {
      let lastRowCell = lastRow.querySelector(".cell");
      let lastRowCellImg = lastRowCell.querySelector("img.photo");
      lastRowCell.style.maxWidth = "33vw";
      lastRowCell.querySelector(".mediawrap").style.maxWidth = "33vw";
      lastRowCellImg.style.height = "auto";
      lastRowCellImg.style.width = "100%";
    }
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined" && arRows != null) {
    arRows(rowsEl);
    if (rowsEl.length > 0) {
      arRowsWidow();
    }
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  //initialize lazyload - sitewide for image
  const lazyLoad = new LazyLoad({
    elements_selector: ".loadmeview",
    callback_enter: loadImage,
  });

  //initialize lazyload - autoplay videos
  const lazyLoadAutoVideo = new LazyLoad({
    elements_selector: ".autovideo",
    threshold: 30,
    callback_enter: playAutoVideo,
    callback_exit: pauseAutoVideo,
  });

  // preload images regardless of area in viewport
  document.querySelectorAll("img.preload").forEach(function (img) {
    loadImage(img);
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    /*
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }
    */

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
      masonGrid.classList.add("loaded");
    }
    msnry.on("layoutComplete", onLayoutComplete);
    msnry.layout();
  });

  //initialize flickity for slideshows

  // BIO SLIDESHOW
  let bioSlideshowEl = document.querySelector(".bio_slideshow");
  if (typeof bioSlideshowEl != "undefined" && bioSlideshowEl != null) {
    let flkty = new Flickity(bioSlideshowEl, {
      // options
      cellSelector: ".slide",
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 2500,
    });
  }

  let slideshowEl = document.querySelector(".slideshow");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let autoplay = 0;
    if (slideshowEl.classList.contains("autoplay")) {
      autoplay = 3500;
    }

    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
      wrapAround: true,
      autoPlay: autoplay,
      pauseAutoPlayOnHover: false,
      on: {
        ready: function () {
          let activeSlide = slideshowEl.querySelector(".cell.is-selected");
          let slideTextColor = activeSlide.getAttribute("data-text-color");
          if (slideTextColor === "white") {
            body.classList.add("white_text");
          } else {
            body.classList.remove("white_text");
          }
        },
      },
    });

    // check for text color attribute on cell
    flkty.on("change", function (index) {
      let activeSlide = slideshowEl.querySelector(".cell.is-selected");
      let slideTextColor = activeSlide.getAttribute("data-text-color");
      if (slideTextColor === "white") {
        body.classList.add("white_text");
      } else {
        body.classList.remove("white_text");
      }
    });

    // arrow click events
    let nextArrow = slideshowEl.querySelector(".arrow.next");
    let prevArrow = slideshowEl.querySelector(".arrow.prev");

    nextArrow.addEventListener("click", function () {
      flkty.pausePlayer();
      flkty.next();
    });
    prevArrow.addEventListener("click", function () {
      flkty.pausePlayer();
      flkty.previous();
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function resizePostIframe(frame) {
    let orgW = frame.getAttribute("width") || 1920,
      orgH = frame.getAttribute("height") || 1080,
      pw = frame.parentElement.clientWidth,
      r = orgH / orgW,
      nw = pw,
      nh = nw * r;

    frame.setAttribute("width", nw);
    frame.setAttribute("height", nh);
  }

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playFullVideo(el) {
    let videoEl = el.querySelector("video.full");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-video");
      let videoHold = el.querySelector(".inner");
      videoHold.innerHTML = videoStr;

      let iframe = videoHold.querySelector("iframe");
      if (typeof iframe != "undefined" && iframe != null) {
        var player = new Player(iframe);
        player.play();
      } else {
        let fullVideoEl = videoHold.querySelector("video.full");
        fullVideoEl.play();
      }
    }
    el.classList.add("full_playing");
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    if (image.classList.contains("loeaded")) {
      return;
    }

    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    let prefix = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = prefix + "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = prefix + "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = prefix + "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = prefix + "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = prefix + "/images/pics/1920/" + img;
      } else {
        imgpath = prefix + "/images/pics/" + img;
      }
    } else {
      imgpath = prefix + "/images/pics/" + img;

      /*
      // load jpg as placeholder, when gif loaded swap
      imgpath = prefix + "/images/pics/500/" + img;
      fullpath = prefix + "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
      */
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
      image.classList.add("loaded");
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  /*
  function closeOverlay() {
    overlay.classList.remove("on");
    body.classList.remove("blur");
  }
  */

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {
    // check for any inline iframes
    let postIframes = document.querySelectorAll(".postpage iframe");
    postIframes.forEach((frame) => {
      resizePostIframe(frame);
    });

    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(
      ".ar-rows .row .cell .mediawrap"
    );
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
    if (rowsEl.length > 0) {
      arRowsWidow();
    }
  }

  window.addEventListener("resize", reportWindowSize);

  /*
  This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.
  
  Features:
   - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
   - When each item animates to the left or right enough, it will loop back to the other side
   - Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
   - The returned timeline will have the following methods added to it:
     - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
     - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
     - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
     - current() - returns the current index (if an animation is in-progress, it reflects the final index)
     - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
   */
  function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
    let tl = gsap.timeline({
        repeat: config.repeat,
        paused: config.paused,
        defaults: { ease: "none" },
        onReverseComplete: () =>
          tl.totalTime(tl.rawTime() + tl.duration() * 100),
      }),
      length = items.length,
      startX = items[0].offsetLeft,
      times = [],
      widths = [],
      xPercents = [],
      curIndex = 0,
      pixelsPerSecond = (config.speed || 1) * 100,
      snap =
        config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
      totalWidth,
      curX,
      distanceToStart,
      distanceToLoop,
      item,
      i;
    gsap.set(items, {
      // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
      xPercent: (i, el) => {
        let w = (widths[i] = parseFloat(gsap.getProperty(el, "width", "px")));
        xPercents[i] = snap(
          (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
            gsap.getProperty(el, "xPercent")
        );
        return xPercents[i];
      },
    });
    gsap.set(items, { x: 0 });
    totalWidth =
      items[length - 1].offsetLeft +
      (xPercents[length - 1] / 100) * widths[length - 1] -
      startX +
      items[length - 1].offsetWidth *
        gsap.getProperty(items[length - 1], "scaleX") +
      (parseFloat(config.paddingRight) || 0);
    for (i = 0; i < length; i++) {
      item = items[i];
      curX = (xPercents[i] / 100) * widths[i];
      distanceToStart = item.offsetLeft + curX - startX;
      distanceToLoop =
        distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
      tl.to(
        item,
        {
          xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
          duration: distanceToLoop / pixelsPerSecond,
        },
        0
      )
        .fromTo(
          item,
          {
            xPercent: snap(
              ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
            ),
          },
          {
            xPercent: xPercents[i],
            duration:
              (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false,
          },
          distanceToLoop / pixelsPerSecond
        )
        .add("label" + i, distanceToStart / pixelsPerSecond);
      times[i] = distanceToStart / pixelsPerSecond;
    }
    function toIndex(index, vars) {
      vars = vars || {};
      Math.abs(index - curIndex) > length / 2 &&
        (index += index > curIndex ? -length : length); // always go in the shortest direction
      let newIndex = gsap.utils.wrap(0, length, index),
        time = times[newIndex];
      if (time > tl.time() !== index > curIndex) {
        // if we're wrapping the timeline's playhead, make the proper adjustments
        vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
        time += tl.duration() * (index > curIndex ? 1 : -1);
      }
      curIndex = newIndex;
      vars.overwrite = true;
      return tl.tweenTo(time, vars);
    }
    tl.next = (vars) => toIndex(curIndex + 1, vars);
    tl.previous = (vars) => toIndex(curIndex - 1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
      tl.vars.onReverseComplete();
      tl.reverse();
    }
    return tl;
  }

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // inline video play click events
  let videoPlayIcons = document.querySelectorAll(".cell .play");
  videoPlayIcons.forEach((videoPlayIcon) => {
    videoPlayIcon.addEventListener("click", function (e) {
      e.preventDefault();
      let cell = videoPlayIcon.closest(".cell");
      playFullVideo(cell);
    });
  });

  // handle header subs on click for mobile vs. hover for desktop

  let list_nav = document.querySelector("header .secondary_nav");
  function closeSecondaryNav() {
    list_nav.classList.remove("open");
    let openLists = list_nav.querySelectorAll(".list");
    openLists.forEach((openList) => {
      openList.classList.remove("open");
    });
  }

  let headerSubTriggers = document.querySelectorAll("header .subTrigger");
  if (window.innerWidth <= 767) {
    headerSubTriggers.forEach((headerSubTrigger) => {
      let firstLink = headerSubTrigger.querySelector("a");

      firstLink.addEventListener("click", function (e) {
        e.preventDefault();
        let listItem = headerSubTrigger.closest("li");
        listItem.classList.toggle("open");
      });
    });
  } else {
    headerSubTriggers.forEach((headerSubTrigger) => {
      headerSubTrigger.addEventListener("mouseenter", function () {
        // close any open lists
        closeSecondaryNav();

        // get the x coordiantes of the trigger so we can update the right position of the secondary nav triangle
        let triggerX = headerSubTrigger.getBoundingClientRect().left;
        let triggerW = headerSubTrigger.offsetWidth;
        let triangle = list_nav.querySelector(".triangle");
        triangle.style.left = triggerX + triggerW / 2 - 8 + "px";
        let listID = headerSubTrigger.getAttribute("data-id");
        let targetList = list_nav.querySelector(
          ".list[data-id='" + listID + "']"
        );
        // add open class to target list
        targetList.classList.add("open");

        // add open class to parent secondary nav
        list_nav.classList.add("open");
      });
    });
  }

  // close secondary nav anytime the user scrolls outside of the header
  if (typeof header != "undefined" && header != null) {
    header.addEventListener("mouseleave", function () {
      closeSecondaryNav();
    });
  }

  // close secondary nav when mouseenters any li that does not have the class subTrigger
  let navItemsNoSub = header.querySelectorAll("nav li:not(.subTrigger)");
  navItemsNoSub.forEach((navItem) => {
    navItem.addEventListener("mouseenter", function () {
      closeSecondaryNav();
    });
  });

  // close secondary nav when mouseenters the logo in the header
  let headerLogo = document.querySelector("header .logo");
  if (typeof headerLogo != "undefined" && headerLogo != null) {
    headerLogo.addEventListener("mouseenter", function () {
      closeSecondaryNav();
    });
  }

  // mobile portfolio filter for artist detail pages
  let mobileFilters = document.querySelectorAll(".mobileFilter");
  mobileFilters.forEach((mobileFilter) => {
    mobileFilter.addEventListener("click", function () {
      let artistHeader = mobileFilter.closest(".artist-details");
      artistHeader.classList.toggle("open");
    });
  });

  // check for bioTrigger class to scroll to bio section of artist page
  let bioTriggers = document.querySelectorAll("a.bioTrigger");
  bioTriggers.forEach((bioTrigger) => {
    bioTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      let targetEl = document.getElementById("artist_bio").offsetTop;
      let targetY = targetEl - 90;
      if (window.innerWidth <= 767) {
        targetY = targetEl - (window.innerHeight - 90);
      }
      // close artist menu
      let artistHeaders = document.querySelectorAll(".artist-details");
      artistHeaders.forEach((artistHeader) => {
        artistHeader.classList.remove("open");
      });
      zenscroll.toY(targetY);
    });
  });

  // check for hash on scroll page to jump to that section
  if (window.location.hash && body.classList.contains("scroll_hash")) {
    let hash = window.location.hash;
    let cleanHash = hash.replace("#", "");
    let targetEl = document.querySelector(
      ".cell[data-count='" + cleanHash + "']"
    ).offsetTop;

    window.scroll(0, targetEl + 110);
  }

  //custom cursor

  /*

  let adjX, adjY;

  function mousemove(e) {
    location.x = e.clientX;
    location.y = e.clientY;

    cursor.style.opacity = 1;

    window.requestAnimationFrame(function () {
      positionCursor(location, cursor);
    });
  }

  function mouseleave() {
    cursor.style.opacity = 0;
  }

  function linkenter() {
    cursor.classList.add("link");
  }

  function linkleave() {
    cursor.classList.remove("link");
  }

  function positionCursor(loc, element) {
    // need to update the offsets based on state of cursor
    adjY = 0;
    adjX = 0;
    element.style.top = loc.y - adjY + "px";
    element.style.left = loc.x - adjX + "px";
  }

  // handle default cursor on window move
  window.addEventListener("mousemove", mousemove);
  body.addEventListener("mouseleave", mouseleave);

  // handle generic links with increased scale on cursor
  const links = document.querySelectorAll("a");
  for (let l = 0; l < links.length; ++l) {
    let link = links[l];
    link.addEventListener("mouseenter", linkenter, false);
    link.addEventListener("mouseleave", linkleave, false);
  }

  // handle non link els with increased scale on cursor
  const cursorlinks = document.querySelectorAll(".cursorlink");
  for (let l = 0; l < cursorlinks.length; ++l) {
    let cursorlink = cursorlinks[l];
    cursorlink.addEventListener("mouseenter", linkenter, false);
    cursorlink.addEventListener("mouseleave", linkleave, false);
  }

  */

  //hamburger menu toggle
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault(), document.body.classList.toggle("menuOn");
    },
    true
  );

  /*
  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true
  );
  */

  // SCROLL ==================================
  let st = 0,
    lastScrollTop = 0;
  window.addEventListener(
    "scroll",
    function () {
      st = window.pageYOffset || document.documentElement.scrollTop;

      if (st > 100) {
        body.classList.add("scroll_down");
      } else {
        body.classList.remove("scroll_down");
      }

      // SECONDARY HEADER show/hide on scroll up/down
      if (body.classList.contains("secondary_nav")) {
        if (st > 100) {
          document
            .querySelector(".artist-secondary-header")
            .classList.add("show");
        } else {
          document
            .querySelector(".artist-secondary-header")
            .classList.remove("show");
        }
      }

      lastScrollTop = st;
    },
    false
  );
});
